import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { shipmentsAPI } from "../../api/shipments/shipments";
import { findClosestShipments } from "./slice/findClosestShipments";
import { getUnixTime } from "../../helpers/time/convertApiTime";
import { savedReceiversAPI } from "../../api/savedReceivers/savedReceiver";

export const shipmentKinds = {
    all: "all",
    sent: "sent",
    not_sent: "not_sent",
}

const initialState = {
    unauthorized: false,
    shipments: [],
    shownShipments: [],
    searchingInput: "",
    searchingParameter: "",
    shipmentsKind: shipmentKinds.all,
    createdShipmentID: null,
    statuses: {
        uploading: null,
        creating: null,
        sendingToAkad: {},
        creatingSavedReceiver: null,
    },
    errors: {
        uploading: null,
        creating: null,
        sendingToAkad: null,
        creatingSavedReceiver: null,
    },
    createShipmentPopup: {
        senderEmail: "",
        senderPhone: "",
        senderFullName: "",
        senderAddress: "",
        senderCompany: "",
        senderCityCode: "",
        senderTownID: "",
        senderDistrictID: "",
        receiverCompany: "",
        receiverName: "",
        receiverAddress: "",
        receiverPhone: "",
        receiverEmail: "",
        receiverGeolocation: {
            city: "",
            country: "Россия",
            district: "",
            area: "",
        },
        receiverDescription: "",
        deliveryType: "",
        deliverySpeed: "",
        packageType: "",
        paymentType: "",
    },
    sendToAkadPopupData: {
        opened: false,
        shipmentID: null,
    }
};

const getShipmentsByKind = (state) => {
    let shipments = JSON.parse(JSON.stringify(state.shipments));
    if (state.shipmentsKind === shipmentKinds.all) {
        return shipments;
    }
    if (state.shipmentsKind === shipmentKinds.sent) {
        return shipments.filter((shipment) => shipment.blocked);
    }
    if (state.shipmentsKind === shipmentKinds.not_sent) {
        return shipments.filter((shipment) => !shipment.blocked);
    }
    return shipments;
};

const updateShownShipmentsByFilter = (state) => {
    let shipments = getShipmentsByKind(state);

    let res = findClosestShipments(
        state.searchingInput,
        state.searchingParameter,
        shipments
    );
    
    state.shownShipments = res ?? [];
};

const filterShownShipments = (state, min, max) => {
    state.shownShipments.sort(
        (a, b) =>
            b.id - a.id
    );
    if (min) {
        state.shownShipments =
            state.shownShipments.filter(
                (shipment) => getUnixTime(shipment["updated-time"]) >= min
            ) ?? [];
    }
    if (max) {
        state.shownShipments =
            state.shownShipments.filter((shipment) => {
                // let a = getUnixTime(shipment["updated-time"]);
                return getUnixTime(shipment["updated-time"]) <= max;
            }) ?? [];
    }
    
};

export const uploadShipments = createAsyncThunk(
    "shipments/uploadShipmnents",
    async (_, { rejectWithValue, dispatch }) => {
        let resp = await shipmentsAPI.upload();
        if (resp.ok) {
            return { shipments: resp.shipments };
        }
        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }
        return rejectWithValue({ err: "something_went_wrong" });
    }
);

export const createShipment = createAsyncThunk(
    "shipments/createShipment",
    async ({ data }, { rejectWithValue, dispatch }) => {
        console.log(data)
        const preparedData = {
            "getting-package-type": data["getting-package-type"],
            "delivery-speed": data["delivery-speed"],
            "package-type": data["package-type"],
            "payment-type": data["payment-type"],
            "declared-price": +data["declared-price"],
            "declared-price-currency": data["declared-price-currency"],
            "sender-city-code": data["sender-city-code"],
            "sender-town-id": +data["sender-town-id"],
            "sender-district-id": +data["sender-district-id"],
            "sender-address": data["sender-address"],
            "B2B-order-type": data["B2B-order-type"],
            "B2B-order-number": +data["B2B-order-number"],
            "receiver-company": data["receiver-company"],
            "receiver-postal-index": data["receiver-postal-index"],
            "receiver-name": data["receiver-name"],
            "receiver-address": data["receiver-address"],
            "receiver-phone-number": data["receiver-phone-number"],
            "receiver-email": data["receiver-email"],
            "receiver-country": data["receiver-country"],
            "receiver-city": data["receiver-city"],
            "receiver-district": data["receiver-district"],
            "receiver-area": data["receiver-area"],
            "receiver-description": data["receiver-description"],
        };

        let resp = await shipmentsAPI.create(preparedData);
        if (resp.ok) {
            return { shipment: resp.shipment };
        }

        if (resp.unauthorized) {
            return rejectWithValue({ err: "unauthorized" });
        }

        if (resp.validationErrors) {
            return rejectWithValue({
                validationErrors: resp.validationErrors,
            });
        }

        if (resp.err) {
            return rejectWithValue({ err: resp.err });
        }

        return rejectWithValue({ err: "something went wrong" });
    }
);

export const createSavedReceiver = createAsyncThunk(
    "shipments/createSavedReceiver",
    async ({ data }, { rejectWithValue }) => {
        let resp = await savedReceiversAPI.createSavedReceiver(data);
        if (resp.ok) {
            return { receiver: resp.receiver };
        }
        if(resp.unauthorized) {
            return rejectWithValue({err: "unauthorized"});
        }
        if(resp.validationErrors) {
            return rejectWithValue({validationErrors: resp.validationErrors});
        }
        if(resp.err) {
            return rejectWithValue({err: resp.err});
        }
        return rejectWithValue({err: "something_went_wrong"});
    }
)

export const sendShipmentToAkad = createAsyncThunk(
    "shipments/sendShipmentToAkad",
    async ({ shipmentID }, { rejectWithValue, dispatch }) => {
        let resp = await shipmentsAPI.sendShipmnentToAkad(shipmentID);
        if (resp.ok) {
            return {shipmentID: shipmentID, shipment: resp.shipment };
        }
        if (resp.unauthorized) {
            return rejectWithValue({shipmentID: shipmentID, err: "unauthorized" });
        }
        if (resp.err) {
            return rejectWithValue({shipmentID: shipmentID, err: resp.err });
        }
        return rejectWithValue({shipmentID: shipmentID, err: "something_went_wrong" });
    }
);

const shipmentsSlice = createSlice({
    name: "shipments",
    initialState,
    reducers: {
        filterShownShipmentByDate(state, action) {
            let min = action.payload.min;
            let max = action.payload.max;
            updateShownShipmentsByFilter(state);
            filterShownShipments(state, min, max);
        },
        openCreatePopup(state, action) {
            state.createShipmentPopup.opened = true;
        },
        openCreatePopupWithChangingData(state, action) {
            const {
                senderCityCode,
                senderTownID,
                senderDistrictID,
                receiverCompany = "",
                receiverName = "",
                receiverAddress = "",
                receiverPhone = "",
                receiverEmail = "",
                receiverGeolocation,
                receiverDescription = "",
                deliveryType = "",
                deliverySpeed = "",
                packageType = "",
                paymentType = "",
            } = action.payload;
            state.createShipmentPopup.opened = true;
            state.createShipmentPopup.senderCityCode = senderCityCode;
            state.createShipmentPopup.senderTownID = senderTownID;
            state.createShipmentPopup.senderDistrictID = senderDistrictID;
            state.createShipmentPopup.receiverCompany = receiverCompany;
            state.createShipmentPopup.receiverName = receiverName;
            state.createShipmentPopup.receiverAddress = receiverAddress;
            state.createShipmentPopup.receiverPhone = receiverPhone;
            state.createShipmentPopup.receiverEmail = receiverEmail;
            if(receiverGeolocation) {
                state.createShipmentPopup.receiverGeolocation = receiverGeolocation;
            }
            
            state.createShipmentPopup.deliveryType = deliveryType;
            state.createShipmentPopup.deliverySpeed = deliverySpeed;
            state.createShipmentPopup.packageType = packageType;
            state.createShipmentPopup.paymentType = paymentType;

            state.createShipmentPopup.receiverDescription = receiverDescription;

        },
        createPopupChangingDataClear(state, aciton) {
            state.createShipmentPopup.opened = false;
            state.createShipmentPopup.senderCityCode = "";
            state.createShipmentPopup.senderTownID = "";
            state.createShipmentPopup.senderDistrictID = "";
            state.createShipmentPopup.receiverCompany = "";
            state.createShipmentPopup.receiverName = "";
            state.createShipmentPopup.receiverAddress = "";
            state.createShipmentPopup.receiverPhone = "";
            state.createShipmentPopup.receiverEmail = "";
        },
        closeCreatePopup(state, action) {
            state.createShipmentPopup.opened = false;
        },
        openSendToAkadPopup(state, action) {
            if (!action.payload.shipmentID) {
                return;
            }
            state.sendToAkadPopupData.opened = true;
            state.sendToAkadPopupData.shipmentID = action.payload.shipmentID;
        },
        closeSendToAkadPopup(state, action) {
            state.sendToAkadPopupData.opened = false;
            state.sendToAkadPopupData.shipmentID = null;
        },
        removeAllShipmentErrors(state, action) {
            state.errors.uploading = null;
            state.errors.creating = null;
        },
        setSearchingParameter(state, action) {
            let { parameter } = action.payload;
            if (!parameter) {
                state.searchingInput = "";
                state.searchingParameter = "";
                return;
            }
            state.searchingParameter = parameter;

            updateShownShipmentsByFilter(state);
        },
        setSearchingInputValue(state, action) {
            let { value } = action.payload;
            if (!value) {
                state.searchingInput = "";
                state.shownShipments = JSON.parse(
                    JSON.stringify(state.shipments)
                );
                return;
            }
            state.searchingInput = value;

            updateShownShipmentsByFilter(state);
        },
        setShipmentsKind(state, action) {
            let { kind } = action.payload;
            if (!kind) {
                state.shipmentsKind = shipmentKinds.not_sent;
                return;
            }

            if (state.kind === kind) {
                return;
            }

            state.shipmentsKind = kind;
            updateShownShipmentsByFilter(state);
            filterShownShipments(state);
        },
        setUnauthorized(state, action) {
            let unauthorized = action.payload;
            if (unauthorized === undefined) {
                return;
            }
            state.unauthorized = unauthorized;
        },
        createShipmentFromCalculator(state, action) {
            let { email, fullName, phone } = action.payload;
            if (!email || !fullName || !phone) {
                return;
            }
            state.createShipmentPopup.fullName = fullName;
            state.createShipmentPopup.phone = phone;
            state.createShipmentPopup.email = email;

            state.createShipmentPopup.opened = true;
        },
        setShipmentToSendToAkadPending(state, action) {
            let shipmentIndex = state.shipments.findIndex(
                (shipment) => shipment.id === action.payload.shipmentID
            );
            if (shipmentIndex === -1) {
                return;
            }
            state.shipments[shipmentIndex].isSending = true;
        },
        resetShipmentSendingToAkadError(state, action) {
            state.errors.sendingToAkad = null;
        },
        setCreatedShipmentID(state, action) {
            state.createdShipmentID = action.payload;
        },
        setCreatingSavedReceiverStatus(state, action) {
            let status = action.payload;
            if (!status) {
                state.statuses.creatingSavedReceiver = null;
                return;
            }
            state.statuses.creatingSavedReceiver = status;
        },
        setCreatingSavedReceiverError(state, action) {
            let error = action.payload;
            if (!error) {
                state.errors.creatingSavedReceiver = null;
                return;
            }
            state.errors.creatingSavedReceiver = error;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(uploadShipments.fulfilled, (state, action) => {
            let { shipments } = action.payload;
            state.shipments = shipments;
            state.shownShipments = JSON.parse(JSON.stringify(state.shipments));
            updateShownShipmentsByFilter(state);
            filterShownShipments(state);

            state.errors.uploading = null;
            state.statuses.uploading = "fulfilled";
        });
        builder.addCase(uploadShipments.pending, (state, action) => {
            state.statuses.uploading = "pending";
            state.errors.uploading = null;
        });
        builder.addCase(uploadShipments.rejected, (state, action) => {
            state.statuses.uploading = "rejected";
            const { err } = action.payload;
            if (err === "unauthorized") {
                state.unauthorized = true;
                return;
            }
            if (err) {
                state.errors.uploading = action.payload.err;
            }
        });

        builder.addCase(createShipment.fulfilled, (state, action) => {
            let { shipment } = action.payload;
            state.shipments.push(shipment);
            
            state.createdShipmentID = shipment.id;
            state.errors.creating = null;
            state.statuses.creating = "fulfilled";

            updateShownShipmentsByFilter(state);
            filterShownShipments(state);
        });
        builder.addCase(createShipment.pending, (state, action) => {
            state.statuses.creating = "pending";
            state.errors.creating = null;
        });
        builder.addCase(createShipment.rejected, (state, action) => {
            state.statuses.creating = "rejected";
            if (action.payload.validationErrors) {
                state.errors.creating = "invalid_data";
                return;
            }

            if (action.payload.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }

            if (action.payload.err) {
                state.errors.creating = action.payload.err;
                return;
            }
            state.errors.creating = "something went wrong";
        });

        builder.addCase(sendShipmentToAkad.fulfilled, (state, action) => {
            let { shipmentID, shipment } = action.payload;
            if (!shipmentID) {
                return;
            }
            
            let shipmentFromStateIndex = state.shipments.findIndex(
                (shipment) => shipment.id === shipmentID      
            );

            if (shipmentFromStateIndex === -1) {
                return;
            }

            state.shipments[shipmentFromStateIndex] = shipment;
            state.shipments[shipmentFromStateIndex].isSending = false;
            updateShownShipmentsByFilter(state);
        });
        builder.addCase(sendShipmentToAkad.rejected, (state, action) => {
            let { shipmentID, err } = action.payload;
            if (!shipmentID) {
                return;
            }
            
            let shipmentFromStateIndex = state.shipments.findIndex(
                (shipment) => shipment.id === shipmentID      
            );

            if (shipmentFromStateIndex === -1) {
                return;
            }

            state.shipments[shipmentFromStateIndex].isSending = false;
            state.errors.sendingToAkad = err ?? "something_went_wrong";
        });

        builder.addCase(createSavedReceiver.fulfilled, (state, action) => {
            state.statuses.creatingSavedReceiver = "fulfilled";
            state.errors.creatingSavedReceiver = null;
        });
        builder.addCase(createSavedReceiver.pending, (state, action) => {
            state.statuses.creatingSavedReceiver = "pending";
            state.errors.creatingSavedReceiver = null;
        });
        builder.addCase(createSavedReceiver.rejected, (state, action) => {
            state.statuses.creatingSavedReceiver = "rejected";
            if (action.payload.validationErrors) {
                state.errors.creatingSavedReceiver = "invalid_data";
                return;
            }

            if (action.payload.err === "unauthorized") {
                state.unauthorized = true;
                return;
            }

            if (action.payload.err) {
                state.errors.creatingSavedReceiver = action.payload.err;
                return;
            }
            state.errors.creatingSavedReceiver = "something went wrong";
        });
    },
});

export const selectShipments = (state) => state.shipments.shipments;
export const selectShownShipments = (state) => state.shipments.shownShipments;
export const selectShipmentsUploadingStatus = (state) =>
    state.shipments.statuses.uploading;
export const selectShipmentUploadingError = (state) =>
    state.shipments.errors.uploading;

export const selectShipmentCreatingStatus = (state) =>
    state.shipments.statuses.creating;
export const selectShipmentCreatingError = (state) =>
    state.shipments.errors.creating;

export const selectShipmentSendingToAkadError = (state) =>
    state.shipments.errors.sendingToAkad;

export const selectCreatePopup = (state) => state.shipments.createShipmentPopup;
export const selectSearchingValue = (state) => state.shipments.searchingInput;
export const selectSearchingParameter = (state) =>
    state.shipments.searchingParameter;

export const selectShipmentsUnauthorized = (state) =>
    state.shipments.unauthorized;

export const selectSendToAkadPopupData = (state) => state.shipments.sendToAkadPopupData;
export const selectSendingToAkadStatus = (state) => state.shipments.statuses.sendingToAkad;

export const selectShipmentsKind = (state) => state.shipments.shipmentsKind;

export const selectCreatedShipmentID = (state) => state.shipments.createdShipmentID;

export const selectCreatingSavedReceiverStatus = (state) => state.shipments.statuses.creatingSavedReceiver;
export const selectCreatingSavedReceiverError = (state) => state.shipments.errors.creatingSavedReceiver;

export const {
    filterShownShipmentByDate,
    openCreatePopup,
    closeCreatePopup,
    openSendToAkadPopup,
    closeSendToAkadPopup,
    setSearchingInputValue,
    setSearchingParameter,
    removeAllShipmentErrors,
    setUnauthorized,
    createShipmentFromCalculator,
    openCreatePopupWithChangingData,
    createPopupChangingDataClear,
    setShipmentToSendToAkadPending,
    resetShipmentSendingToAkadError,
    setShipmentsKind,
    setCreatedShipmentID,
    setCreatingSavedReceiverStatus,
    setCreatingSavedReceiverError,
} = shipmentsSlice.actions;

export default shipmentsSlice.reducer;
